export function sortItemsBySortedIdsArray<T, K extends keyof T>(
    listOfItems: T[],
    sortedIdsArray: string[],
    idProp: K = 'id' as K,
): T[] {
    return listOfItems.sort(
        (a, b) => sortedIdsArray.indexOf(a[idProp] as string) - sortedIdsArray.indexOf(b[idProp] as string),
    );
}
